<template>
  <div :style="{ margin: margin, boxShadow: boxShadow, backgroundColor: bgColor, borderRadius: '4px' }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LayoutBlockSection',
  props: {
    margin: {
      type: String,
      required: true,
    },
    shadow: {
      type: Boolean,
      default: true,
    },
    bgColor: {
      type: String,
      default: '#FFFFFF',
    },
  },
  computed: {
    boxShadow() {
      if (this.shadow) return '0px 35px 15px -30px rgba(0,0,0,0.16),0px -15px 15px -21px rgba(0,0,0,0.16)'
      else return 'none'
    },
  },
}
</script>
